import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { useMail } from '../../context/MailContext';
import './Topbar.css';

export default function Topbar() {
  const { user, logout } = useAuth();
  const { theme, setTheme } = useTheme();
  const { search, setSearch, openCompose } = useMail();
  const [profileOpen, setProfileOpen] = useState(false);

  return (
    <header className="topbar">
      <div className="topbar-brand">
        <div className="brand-logo">E</div>
        <div className="brand-text">
          <span className="brand-name">Ellertek Mail</span>
          <span className="brand-domain">barua.ellertek.co.tz</span>
        </div>
      </div>

      <div className="topbar-search">
        <span className="search-icon">⌕</span>
        <input
          className="search-input"
          placeholder="Search emails, people, attachments…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        {search && (
          <button className="search-clear" onClick={() => setSearch('')}>✕</button>
        )}
      </div>

      <div className="topbar-right">
        <div className="theme-switcher">
          <button
            className={`theme-opt ${theme === 'light' ? 'active' : ''}`}
            onClick={() => setTheme('light')}
          >☀ Light</button>
          <button
            className={`theme-opt ${theme === 'dark' ? 'active' : ''}`}
            onClick={() => setTheme('dark')}
          >☾ Dark</button>
        </div>

        <button className="topbar-icon-btn notif-btn" title="Notifications">
          🔔
          <span className="notif-badge">3</span>
        </button>

        <div className="profile-wrap" onClick={() => setProfileOpen(o => !o)}>
          <div className="profile-avatar">{user?.initials || 'ME'}</div>
          {profileOpen && (
            <div className="profile-dropdown">
              <div className="profile-info">
                <div className="profile-name">{user?.name}</div>
                <div className="profile-email">{user?.email}</div>
              </div>
              <div className="profile-divider"></div>
              <button className="profile-item" onClick={() => setProfileOpen(false)}>
                ⚙ Settings
              </button>
              <button className="profile-item" onClick={logout}>
                ↩ Sign out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
